export function getList(param) {
    return new Promise((resolve, reject) => {
      axios.post("/admin/login", param).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        });
    });
  }